// @ts-check

import { useState } from "react";
import SubmissionFieldCommentModal from '~/components/Forms/SubmissionFieldCommentModal';
import FailedFieldsModal from '~/components/Forms/FailedFieldsModal';

export default function SubmissionAnalyticsBlock({ submission }) {
    const [showFailedFieldsModal, setShowFailedFieldsModal] = useState(false);
    const [showCommentsModalMode, setShowCommentsModalMode] = useState(null);

    return (
        <>
            {showCommentsModalMode && (
                <SubmissionFieldCommentModal
                    show
                    cancel={() => setShowCommentsModalMode(null)}
                    submission_uuid={submission.submission_uuid}
                    mode={showCommentsModalMode}
                />
            )}
            {showFailedFieldsModal && (
                <FailedFieldsModal
                    show
                    cancel={() => setShowFailedFieldsModal(false)}
                    submission_uuid={submission.submission_uuid}
                />
            )}
            <div className="panel thin-border" style={{ margin: "0 0 1rem 0" }}>
                <div className="panel no-padding-print top-margin-print" style={{ padding: "1rem", margin: 0 }}>
                    <div className="SubmissionAnalyticsBlock">
                        <div className="no-padding-print">
                            <p className="text-sm text-bold zero-blue text-center" style={{ margin: "0.5rem" }}>
                                Score
                            </p>
                            <div className="SubmissionAnalyticsBlock-value">
                                <p
                                    className="zero-blue text-center mar-btm-0 "
                                >
                                    {submission.score}
                                    {!isNaN(submission.score) && <span style={{ fontSize: "30%" }}>%</span>}
                                </p>
                            </div>
                        </div>

                        <div className="no-padding-print">
                            <p className="text-sm text-bold zero-blue text-center" style={{ margin: "0.5rem" }}>
                                Failed Items
                            </p>
                            <div
                                className="SubmissionAnalyticsBlock-value"
                                style={{ cursor: "pointer" }}
                                onClick={() => setShowFailedFieldsModal(true)}
                            >
                                <p
                                    className="zero-blue text-center mar-btm-0"
                                >
                                    {submission.failed_items_count ?? 0}
                                </p>
                            </div>
                        </div>

                        <div className="no-padding-print">
                            <p className="text-sm text-bold zero-blue text-center" style={{ margin: "0.5rem" }}>
                                Comments
                            </p>
                            <div
                                className="SubmissionAnalyticsBlock-value"
                                style={{ cursor: "pointer" }}
                                onClick={() => setShowCommentsModalMode('comments')}
                            >
                                <p
                                    className="zero-blue text-center mar-btm-0"
                                >
                                    {submission.comment_count ?? 0}
                                </p>
                            </div>
                        </div>

                        <div className="no-padding-print">
                            <p className="text-sm text-bold zero-blue text-center" style={{ margin: "0.5rem" }}>
                                Files
                            </p>
                            <div
                                className="SubmissionAnalyticsBlock-value"
                                style={{ cursor: "pointer" }}
                                onClick={() => setShowCommentsModalMode('attachments')}
                            >
                                <p
                                    className="zero-blue text-center mar-btm-0"
                                >
                                    {submission.attachment_count ?? 0}
                                </p>
                            </div>
                        </div>

                        <div className="no-padding-print">
                            <p className="text-sm text-bold zero-blue text-center" style={{ margin: "0.5rem" }}>
                                To-Dos
                            </p>
                            <div className="SubmissionAnalyticsBlock-value">
                                <p
                                    className="zero-blue text-center mar-btm-0"
                                >
                                    {submission.task_count ?? 0}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
